// src/modulos/Dashboard/dashboards/MarketingDashboard.js
import React from 'react';

const MarketingDashboard = ({ user }) => {
    return (
        <div>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '20px', marginTop: '30px' }}>
                <div style={{ padding: '20px', border: '1px solid #9c27b0', borderRadius: '8px', backgroundColor: '#f3e5f5' }}>
                    <h3>📈 Performance de Campanhas</h3>
                    <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
                        <li>Campanha ativa: 3</li>
                        <li>CTR médio: 4.2%</li>
                        <li>Conversões: 156</li>
                        <li>ROI médio: 320%</li>
                    </ul>
                </div>

                <div style={{ padding: '20px', border: '1px solid #ccc', borderRadius: '8px', backgroundColor: '#fff' }}>
                    <h3>📱 Redes Sociais</h3>
                    <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
                        <li>Novos seguidores: +245</li>
                        <li>Engajamento: +12%</li>
                        <li>Posts agendados: 8</li>
                        <li>Menções: 34</li>
                    </ul>
                </div>

                <div style={{ padding: '20px', border: '1px solid #ccc', borderRadius: '8px', backgroundColor: '#fff' }}>
                    <h3>🎯 Geração de Leads</h3>
                    <ul style={{ marginTop: '10px', paddingLeft: '20px' }}>
                        <li>Leads este mês: 432</li>
                        <li>Qualificados: 89</li>
                        <li>Convertidos: 23</li>
                        <li>Custo por lead: R$ 45</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default MarketingDashboard;